import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);
import {
  Component,
  OnInit,
  OnChanges,
  Input,
  ViewChildren,
  ViewChild,
  SimpleChanges,
} from "@angular/core";
import { BenchmarkDataPrimaryLookupService, BmarkFixingData } from "shared/cubiq-services";
import { BmarkClientOrdersBlotterMode } from "../../shared/cubiq-services/model/benchmarks/enums/BmarkClientOrdersBlotterMode.enum";
import { BmarkHedgeOrdersBlotterComponent } from "./blotters/hedge-orders/bmark-hedge-orders-blotter.component";
import { ChildBlotterComponent } from "./models/bmark-sub-blotter.interface";
import { FilterConfiguration } from "../bfx-blotter-filter/FilterConfiguration";

@Component({
  selector: "bmark-summary-hedge-orders",
  templateUrl: "./html/bmark-summary-hedge-orders.html",
  standalone: false,
})
export class BmarkSummaryHedgeOrdersComponent implements OnInit, ChildBlotterComponent, OnChanges {
  @Input() activeView: BmarkClientOrdersBlotterMode;
  @Input() fixingData: BmarkFixingData;

  @ViewChild("bmarkHedgeOrders")
  public bmarkHedgeOrdersBlotter: BmarkHedgeOrdersBlotterComponent;

  /**********************************************************************/
  /* DATA */
  public orderIds: string = "";

  /**********************************************************************/
  /* CONSTRUCTOR */
  constructor() {}

  /**********************************************************************/
  /* INITIALIZE */
  ngOnInit() {
    this.initialize();
  }

  protected initialize(): void {}

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      switch (propName) {
        case "activeView": {
          if (null != this.bmarkHedgeOrdersBlotter) {
            this.bmarkHedgeOrdersBlotter.setBmarkViewType(this.activeView);
          } else {
            logger.out.warn("ngOnCHanges with no bmarkHedgeOrdersBlotter");
          }
          break;
        }
      }
    }
  }
  public getBlotterId() {
    return this.bmarkHedgeOrdersBlotter.getBlotterId();
  }

  public getBlotterInstance() {
    return this.bmarkHedgeOrdersBlotter.getBlotterInstance();
  }
  /**********************************************************************/
  /* BLOTTER */
  public getHedgeOrdersConfiguration(): any {
    return this.bmarkHedgeOrdersBlotter.getComponentConfiguration();
  }

  filterSelectionChanged(filterConfiguration: FilterConfiguration) {
    this.bmarkHedgeOrdersBlotter.filterAppliedEvent();
    this.bmarkHedgeOrdersBlotter.filterSelectionChanged(filterConfiguration);
  }

  getFilterConfiguration(): void {
    return this.bmarkHedgeOrdersBlotter.getFilterConfiguration();
  }

  setBlotterFilterComponent(blotterFilter: any): void {
    this.bmarkHedgeOrdersBlotter.setBlotterFilterComponent(blotterFilter);
  }

  refreshSelectionCells(): void {
    this.bmarkHedgeOrdersBlotter.refreshSelectionCells();
  }

  hasCellRenderedSelection(): boolean {
    return this.bmarkHedgeOrdersBlotter.hasCellRenderedSelection();
  }

  public getProfileSettingKey(): string {
    return this.bmarkHedgeOrdersBlotter.getProfileSettingKey();
  }
}
